import { createFileRoute } from "@tanstack/react-router";

import { WelcomeStep } from "core/models/welcome";

import { useStoreWelcome } from "areas/welcome/store";
import { query } from "areas/welcome/data";
import Welcome from "areas/welcome/pages/Welcome";


export const Route = createFileRoute("/_private/welcome/$partnerId")({
	component: () => <Welcome />,
	loader: async ({ context, params }) => {
		const { queryClient } = context;
		const config = await queryClient.ensureQueryData(query.config(params.partnerId));
		const welcome = useStoreWelcome.getState();

		if (!config.step) welcome.setStep(WelcomeStep.One);
		else if (config.step != welcome.step) welcome.setStep(config.step);
	},
	staticData: {
		footer: true
	}
});